<script setup lang="ts">
import { faCalendarDays, faClockSeven } from '@fortawesome/pro-light-svg-icons'

const { episode } = defineProps<{
  episode: PodcastRssEpisode
}>()

const site = useSiteConfig()

const timeProps = computed(() => ({
  itemprop: 'datePublished',
  datetime: episode.isoDate,
  locale: site.defaultLocale,
  day: '2-digit' as const,
  month: '2-digit' as const,
}))
</script>

<template>
  <div class="flex @container w-full">
    <div class="flex items-center gap-3xs @xs:gap-2xs">
      <Icon :icon="faCalendarDays" size="sm" class="@xs:size-5" />
      <NuxtTime year="2-digit" class="@xs:hidden" v-bind="timeProps" />
      <NuxtTime year="numeric" class="hidden @xs:block" v-bind="timeProps" />
    </div>

    <div class="flex items-center gap-3xs @xs:gap-2xs">
      <Icon :icon="faClockSeven" size="sm" class="@xs:size-5" />

      <span v-text="episode.duration" />
    </div>

    <slot />
  </div>
</template>
